// extracted by mini-css-extract-plugin
export default {"form":"LGRE0","form_hidden":"E1mXC","form__submit":"eMJvc","form__submit_hidden":"oxEM3","form__text-area":"cmC2r"};